<template>
  <re-page
    max-width="xl"
    :page-title="$t('monolith.apps.dashboard')"
    :tooltip="$t('monolith.dashboard.title_tooltip')"
    class="bg-light"
    main-content-class="q-pa-md"
  >
    <DashboardBase
      show-customer-ref-filter
      is-expandable
      :show-header-filters="false"
    />
  </re-page>
</template>

<script setup>
import { computed, provide } from 'vue'

import { getLegacyActionButtons } from '@/apps/MainApp/views/Dashboard/ActionButtons/legacyActionButtons'
import { getSharedActionsButtons } from '@/apps/MainApp/views/Dashboard/ActionButtons/sharedActionButtons'
import {
  registerActionColumn,
  registerAppointmentColumn,
  registerBorrowerColumn,
  registerBuildingTypeColumn,
  registerCreatedAtColumn,
  registerCustomerRefColumn,
  registerDisplayAddressWithBuildingTypeColumn,
  registerLastCycleStartAtColumn,
  registerLastSubmissionLangColumn,
  registerModifiedAtColumn,
  registerOwnerColumn,
  registerStatusColumn,
  registerTenantColumn,
  registerValuationRequestRefColumn,
  registerValuationTypeColumn,
  registerValuerColumn,
} from '@/apps/MainApp/views/Dashboard/Base/columns/index.js'
import DashboardBase from '@/apps/MainApp/views/Dashboard/Base/DashboardBase.vue'
import { useConfig } from '@/composables/useConfig'
import { useCurUser } from '@/composables/useCurUser'
import { useDashboardRequestList } from '@/composables/useDashboardRequestList'
import { actionButtonsKey, dashboardInstallerKey, requestListKey } from '@/keys'

import { getOnsiteDispatcherActionButtons } from '../ActionButtons/onsiteDispatcherActionButtons'

const config = useConfig()
const { hasRole } = useCurUser()

const isMultiTenant = computed(() => !!config.DISPATCHED_DEPLOYMENTS?.length)

const isDvmValuer = computed(() => hasRole('valuer', 'dvm'))

const requestList = useDashboardRequestList()
provide(requestListKey, requestList)

provide(actionButtonsKey, [getOnsiteDispatcherActionButtons, getLegacyActionButtons, getSharedActionsButtons])
provide(dashboardInstallerKey, (dashboard, { showDuplicates, dateColor, requests, colFilters }) => {
  if (isMultiTenant.value) {
    registerTenantColumn(dashboard)
  }

  registerDisplayAddressWithBuildingTypeColumn(dashboard)
  registerCustomerRefColumn(dashboard)
  registerValuationTypeColumn(dashboard)
  registerStatusColumn(dashboard)

  registerValuationRequestRefColumn(dashboard, {
    showDuplicates,
  })
  registerBuildingTypeColumn(dashboard, false, true)
  registerAppointmentColumn(dashboard, {
    dateColor,
    colFilters,
  })
  registerCreatedAtColumn(dashboard)
  registerModifiedAtColumn(dashboard)

  if (isDvmValuer.value) {
    registerLastCycleStartAtColumn(dashboard)
  }

  registerActionColumn(dashboard)
  registerOwnerColumn(dashboard, { requests })
  registerBorrowerColumn(dashboard, { requests, colFilters })
  registerValuerColumn(dashboard)
  registerLastSubmissionLangColumn(dashboard)
})
</script>
